import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useTracker } from '@/core/tracking';

import expandIcon from '@/public/images/icons/expand.svg';
import { MouseEventHandler } from 'react';
import { mediaShownInComparerState } from '@/stores/mediaStore';
import { fitStateFamily, scaleSelectorFamily } from '../../../comparer';

export function MobileScaleRangeSlider({
  className = '',
}: {
  className?: string;
}) {
  const image = useRecoilValue(mediaShownInComparerState);

  const { inputUrl, outputUrl }: { inputUrl?: string; outputUrl?: string } =
    image.id ? image : {};

  const setFit = useSetRecoilState(fitStateFamily(`${inputUrl}:${outputUrl}`));
  const scale = useRecoilValue(scaleSelectorFamily(`${inputUrl}:${outputUrl}`));

  const { track } = useTracker();

  // Do not settle for the default values
  if (!inputUrl || !outputUrl) {
    return <ControlledScale value={1} />;
  }

  return (
    <ControlledScale
      className={className}
      value={scale}
      onFitToScreen={() => {
        track('editor', 'fitted');
        setFit('contain');
      }}
    />
  );
}

function ControlledScale({
  className = '',
  value,
  onFitToScreen,
}: {
  className?: string;
  value: number;
  onFitToScreen?: MouseEventHandler;
}) {
  const percentageValue = Math.floor(value * 100);
  return (
    <div className={`flex items-center space-s-2 ${className}`}>
      {/* Fit to screen */}
      <button type="button" onClick={onFitToScreen}>
        <img {...expandIcon} alt="Fit to screen" />
      </button>

      {/* Current scale */}
      <p className="tabular-nums M18">{percentageValue}%</p>
    </div>
  );
}
